// extracted by mini-css-extract-plugin
export default {"main":"Main_main__FRT00","container":"Main_container__a3K6W"};